<script lang="ts">

	import { type Achievement, AchievementProgressState } from '../../../../domain/Achievement';

	export let achievement: Achievement;
	export let headline: string;
	export let headlineAriaLabel: string | undefined = undefined;

	const backgroundColor = () => {
		switch (achievement.progress.state) {
			case AchievementProgressState.EXPIRED:
				return "grey_background bold";
			case AchievementProgressState.COLLECTED:
				return "success_background bold";
			default:
				return "text-secondary";
		}
	};

</script>

<div class="achievement-body" data-testid="achievement-body">
	<div aria-label={headlineAriaLabel} class={`oc-copy-75 ${backgroundColor()}`}>
		{headline}
	</div>
	<div class="oc-headline-50">{achievement.content.card.title}</div>
	<div class="oc-copy-75">{achievement.content.card.description}</div>
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .grey_background {
    background-color: #E5E5E5;
    padding: 2px 4px;
    display: inline-block;
    border-radius: 2px;
  }
  .success_background {
    background-color: #64C8B9;
    padding: 2px 4px;
    display: inline-block;
    border-radius: 2px;
  }
  .text-secondary {
    color: tokens.$oc-semantic-color-text-secondary
  }
</style>
